<template>
  <v-dialog
    v-model="opened"
    content-class="add-park"
    max-width="400"
    persistent
  >
    <h3 class="add-park__title">
      {{ title }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form
      ref="add-park"
      :class="{ 'disabled-area': !$can('car_park_edit') }"
      @submit.prevent="item ? onUpdate() : onCreate()"
    >
      <v-text-field
        v-model="name"
        outlined
        dense
        :disabled="loading"
        :label="$t('companiesList.tableHeaders.name')"
        :rules="[isRequired]"
      />
      <v-textarea
        v-model="description"
        height="100"
        outlined
        dense
        no-resize
        :disabled="loading"
        :label="$t('common.table.description')"
        :rules="[isRequired]"
      />

      <v-btn
        v-if="$can('car_park_edit')"
        type="submit"
        color="warning"
        block
        elevation="0"
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    name: '',
    description: '',
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs['add-park'].reset();
        this.loading = false;
        setTimeout(() => this.$emit('closed'), 300);
      }
    },
    item: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!value || !value.name) return;

        this.name = value.name;
        this.description = value.description;
      },
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      if (!this.$can('car_park_edit') && this.item) return this.item.name;
      return this.item ? this.$t('common.btns.edit') : this.$t('parks.add');
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    async onCreate() {
      const isValid = this.$refs['add-park'].validate();

      if (!isValid) return;

      this.loading = true;

      const result = await this.$store.dispatch('parks/addNew', {
        name: this.name,
        description: this.description,
      });

      this.$emit('updated', result);
    },
    async onUpdate() {
      const isValid = this.$refs['add-park'].validate();

      if (!isValid) return;

      this.loading = true;

      const formData = {
        name: this.name,
        description: this.description,
      };

      const result = await this.$store.dispatch('parks/updateItem', {
        id: this.item.id,
        formData,
      });

      this.$emit('updated', result);
    },
  },
};
</script>

<style lang="scss">
.add-park {
  padding: 10px;
  background-color: #fff;

  &__title {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
